export default __webpack_public_path__ + "static/media/testimonial_simple.85b94276.png";